/**
 * InviteMessageInput component
 * Personal message textarea
 */

import React, { useCallback } from 'react';
import { View, Text, TextInput } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { useInviteModalStyles } from '../../../src/friends/contexts/InviteModalStylesContext';
import { sanitizeInput, MAX_MESSAGE_LENGTH } from '../../../src/helpers/sanitizeInput.helper';

interface InviteMessageInputProps {
  value: string;
  onChange: (message: string) => void;
}

export const InviteMessageInput: React.FC<InviteMessageInputProps> = ({ value, onChange }) => {
  const theme = useTheme();
  const styles = useInviteModalStyles();
  const handleChange = useCallback(
    (text: string) => {
      const sanitized = sanitizeInput(text);
      onChange(sanitized);
    },
    [onChange]
  );

  return (
    <View style={styles.messageContainer}>
      <Text style={styles.messageLabel}>Personal Message (Optional)</Text>
      <TextInput
        style={styles.messageInput}
        placeholder="Add a personal message..."
        placeholderTextColor={theme.gray[600]}
        value={value}
        onChangeText={handleChange}
        multiline
        maxLength={MAX_MESSAGE_LENGTH}
      />
    </View>
  );
};

